import { useState } from "react";

function FileUpload({ onUpload }) {
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;
    setFile(selectedFile);
    onUpload(selectedFile); // Trigger file upload
  };

  return (
    <div className="upload-section">
      <h2>Upload an Invoice</h2>
      <label className="file-upload">
        <input type="file" onChange={handleFileChange} accept=".pdf,.txt" />
        <div className={`upload-box ${file ? "uploaded" : ""}`}>
          {file ? <p>{file.name}</p> : <p>Drag & Drop or Click to Upload</p>}
        </div>
      </label>
    </div>
  );
}

export default FileUpload;
